import { render, staticRenderFns } from "./StatementDocumentViewer.vue?vue&type=template&id=4bab7e3b"
import script from "./StatementDocumentViewer.vue?vue&type=script&lang=js"
export * from "./StatementDocumentViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports